import onTeamUpdated from './onTeamUpdated';
import onTeamSubscriptionUpdated from './onTeamSubscriptionUpdated';
import onTeamInviteAccepted from './onTeamInviteAccepted';

export default {
  onTeamUpdated,
  onTeamSubscriptionUpdated,
  onTeamInviteAccepted,
};
